<mat-stepper [linear]="false" #stepper [selectedIndex]="selectedIndex" (selectionChange)="matStepperStepChange($event)">
    <mat-step label="Select App" [stepControl]="firstFormGroup">
        <div class="row w-100">
            <mat-form-field class="col-6 m-auto" appearance="outline" appRemoveAriaOwns>
                <mat-label>Select App</mat-label>
                <mat-select [formControl]="appControl" required #select>
                    <mat-select-trigger [textContent]="appControl.value?.displayName ?? appControl.value?.name"></mat-select-trigger>
                    <mat-option>None</mat-option>
                    <mat-form-field class="searchEntities searchInputField selectFilter">
                        <input matInput placeholder="Search App" type="text" [(ngModel)]="selectApp" stop-propagation />
                        <material-button
                            buttonType="icon"
                            [size]="'small'"
                            matSuffix
                            (buttonClicked)="selectApp = ''"
                            [prefixIcon]="selectApp ? 'close' : 'search'"
                            [classList]="['searchEntitiesIcons']"></material-button>
                    </mat-form-field>
                    <ng-container *ngFor="let app of apps | multiFilter : selectApp; trackBy: trackByFn">
                        <ng-container [ngSwitch]="app.assetType">
                            <ng-container *ngSwitchCase="'BRIDGE_ASSET'">
                                <mat-option [value]="app" (click)="getSubApps(app)">
                                    <span class="d-flex align-items-center">
                                        <span *ngIf="select?.panelOpen" class="material-icons mr-3 text-[19px] text-[green]">list</span>
                                        <span [textContent]="app.displayName ?? app.name"></span>
                                    </span>
                                </mat-option>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <mat-option [value]="app" (click)="resetBridgeStatus()">
                                    <span class="d-flex align-items-center">
                                        <span *ngIf="select?.panelOpen" class="material-icons mr-3 text-[19px] text-[green]">article</span>
                                        <span [textContent]="app.displayName ?? app.name"></span>
                                    </span>
                                </mat-option>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </mat-select>
                <mat-error *ngIf="appControl.hasError('required')">Please choose an app</mat-error>
            </mat-form-field>
            <mat-form-field class="col-6 m-auto" appearance="outline" *ngIf="subAppsPresent" appRemoveAriaOwns>
                <mat-label>Select Sub App</mat-label>
                <mat-select [formControl]="subAppControl" required>
                    <mat-option>None</mat-option>
                    <ng-container *ngFor="let app of subApps | ObjNgFor; trackBy: trackByFn">
                        <mat-option [value]="subApps[app]" *ngIf="subApps[app].componentType === 'ASSET'">
                            <span [textContent]="subApps[app].displayName || subApps[app].name"></span>
                        </mat-option>
                    </ng-container>
                </mat-select>
                <mat-error *ngIf="subAppControl.hasError('required')">Please choose a sub app</mat-error>
            </mat-form-field>
        </div>
        <div class="d-flex justify-content-end">
            <material-button
                [buttonType]="'raised'"
                matStepperNext
                [disabled]="!appControl.value || (subAppsPresent && !subAppControl.value)"
                (buttonClicked)="onNextClick()"
                [color]="'primary'"
                [text]="'Next'"></material-button>
        </div>
    </mat-step>
    <mat-step label="Pre-Capture Attributes" [optional]="isOptional" [stepControl]="secondFormGroup">
        <div class="row w-100">
            <ng-container *ngIf="filingAttributeFields?.length > 0; else noFilingAtributes">
                <ng-container *ngFor="let field of filingAttributeFields">
                    <div class="col-4" *ngIf="!field.autoCalculate && field.show">
                        <filingattribute-field
                            [field]="field"
                            [record]="filingAttributeFields"
                            [service]="subAppControl?.value || appControl?.value"
                            [type]="'filingDate'"></filingattribute-field>
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #noFilingAtributes>
                <p class="text-center">No filing attributes found for this app.</p>
            </ng-template>
        </div>
        <div class="d-flex justify-content-end">
            <material-button
                class="stepBtns"
                [buttonType]="'raised'"
                (buttonClicked)="stepper.previous()"
                [text]="'Back'"></material-button>
            <material-button
                [color]="'primary'"
                [buttonType]="'raised'"
                (buttonClicked)="validateFilingAttributes()"
                [text]="'Next'"></material-button>
        </div>
    </mat-step>
    <mat-step label="Select Transformation" [stepControl]="thirdFormGroup">
        <div class="row w-100">
            <mat-form-field class="w-50 m-auto" appearance="outline" appRemoveAriaOwns>
                <mat-label>Select Transformation</mat-label>
                <mat-select [formControl]="transformationControl" required (selectionChange)="transformationSelectionChange()">
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let transformation of sourcePartTransformations" [value]="transformation">
                        <span [textContent]="transformation.displayName ?? transformation.name"></span>
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="transformationControl.hasError('required')">Please choose an transformation</mat-error>
            </mat-form-field>
        </div>
        <div class="d-flex justify-content-end">
            <material-button
                class="stepBtns"
                [buttonType]="'raised'"
                (buttonClicked)="stepper.previous()"
                [text]="'Back'"></material-button>
            <material-button
                [buttonType]="'raised'"
                [disabled]="!transformationControl.value"
                [color]="'primary'"
                (buttonClicked)="stepper.next()"
                [text]="'Next'"></material-button>
        </div>
    </mat-step>
    <mat-step label="Review Association" [optional]="isOptional">
        <div class="row">
            <div class="col-3 text-success mb-3">Source App&nbsp;:</div>
            <div class="col-3" [textContent]="sourceApp?.displayName"></div>
            <div class="col-3 text-success mb-3">Target App&nbsp;:</div>
            <div
                class="col-3"
                [textContent]="
                    subAppsPresent ? subAppControl?.value?.displayName || subAppControl?.value?.name : appControl?.value?.displayName
                "></div>
            <div class="col-3 text-success mb-3">Selected Transformation&nbsp;:</div>
            <div
                class="col-3"
                [textContent]="transformationControl?.value?.chainDisplayName || transformationControl?.value?.displayName"></div>
        </div>
        <div class="d-flex justify-content-end">
            <material-button class="stepBtns" [buttonType]="'raised'" (buttonClicked)="stepper.previous()">Back</material-button>
            <material-button [buttonType]="'raised'" (buttonClicked)="stepper.reset()">Reset</material-button>
            <material-button
                [buttonType]="'raised'"
                (buttonClicked)="submitConsolidation()"
                [text]="'Submit'"
                [color]="'primary'"
                [disabled]="!transformationControl.value"></material-button>
        </div>
    </mat-step>
</mat-stepper>
